// Standard syllabic readings for Linear A signs that are shared with Linear B.
// Edited at runtime via the Sound Shift module / Hypothesis Workspace.
export const PHONETIC_MAP: Record<string, string> = {
  A: "a", E: "e", I: "i", O: "o", U: "u",
  DA: "da", DE: "de", DI: "di", DU: "du",
  JA: "ja", JE: "je", JU: "ju",
  KA: "ka", KE: "ke", KI: "ki", KO: "ko", KU: "ku",
  MA: "ma", ME: "me", MI: "mi", MU: "mu",
  NA: "na", NE: "ne", NI: "ni", NU: "nu",
  PA: "pa", PI: "pi", PO: "po", PU: "pu",
  QA: "kwa", QE: "kwe",
  RA: "ra", RE: "re", RI: "ri", RO: "ro", RU: "ru",
  SA: "sa", SE: "se", SI: "si", SU: "su",
  TA: "ta", TE: "te", TI: "ti", TO: "to", TU: "tu",
  WA: "wa", WE: "we", WI: "wi", WO: "wo",
  ZA: "dza", ZE: "dze", ZO: "dzo",
};
